export const SF_UNIVERSAL_CLASS = 'js-sf-instance';
